import e from "./_baseFor.js";
import t from "./keys.js";
function m(r, o) {
  return r && e(r, o, t);
}
export {
  m as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseForOwn.js
// module id = 1470
// module chunks = 67